<template>
  <v-menu offset-y :key="isAnotherFlux">
    <template v-slot:activator="{ on, attrs }">
      <v-tooltip eager activator="#targetRef" left>
        <span>{{ $t("customers.cant-change-language") }}</span>
      </v-tooltip>

      <v-list-item
        :id="[isAnotherFlux ? 'targetRef' : '']"
        color="primary"
        dark
        v-bind="attrs"
        v-on="on"
      >
        <v-list-item-title>{{ $t("customers.language") }}</v-list-item-title>
        <v-icon>mdi-web</v-icon>
      </v-list-item>
    </template>
    <v-list v-if="!isAnotherFlux">
      <v-list-item
        v-for="locale in locales"
        :key="locale.value"
        @click="updateLocale(locale.value)"
      >
        <v-img :src="locale.image" width="20" class="mr-2"></v-img>
        <v-list-item-title>{{ locale.title }}</v-list-item-title>
        <v-icon v-if="locale.value === $i18n.locale">mdi-check</v-icon>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import br from "../../assets/flags/br.svg";
import us from "../../assets/flags/us.svg";
import es from "../../assets/flags/es.svg";

export default {
  name: "LanguageMenu",
  data() {
    return {
      locales: [
        {
          title: "Português",
          value: "pt_BR",
          image: br,
        },
        {
          title: "Inglês",
          value: "en_US",
          image: us,
        },
        {
          title: "Espanhol",
          value: "es_ES",
          image: es,
        },
      ],
    };
  },
  computed: {
    fluxRoutes() {
      return ["/gerenciar/editar-evento", "/gerenciar/cadastrar"];
    },
    isAnotherFlux() {
      return this.fluxRoutes.includes(this.$route.path);
    },
  },
  methods: {
    updateLocale(locale) {
      this.$i18n.locale = locale;
      this.$axios.setCookie("elevenAdminLocale", locale);
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped></style>
